import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { bytesToHex, hexToBytes, intToBigInt } from '@stacks/common';
import { StacksNetwork, StacksMainnet, StacksTestnet, createFetchFn } from '@stacks/network';
import { c32address } from 'c32check';
import { createMultiSigSpendingCondition, createSingleSigSpendingCondition, createSponsoredAuth, createStandardAuth } from './authorization';
import { AddressHashMode, AddressVersion, PayloadType, PostConditionMode, TransactionVersion, RECOVERABLE_ECDSA_SIG_LENGTH_BYTES, StacksMessageType } from './constants';
import { validateContractCall } from './contract-abi';
import { createStacksPrivateKey, createStacksPublicKey, getPublicKey, pubKeyfromPrivKey, publicKeyFromBytes, publicKeyToAddress, publicKeyToString } from './keys';
import { createContractCallPayload, createSmartContractPayload, createTokenTransferPayload, serializePayload } from './payload';
import { createFungiblePostCondition, createNonFungiblePostCondition, createSTXPostCondition } from './postcondition';
import { createContractPrincipal, createStandardPrincipal } from './postcondition-types';
import { TransactionSigner } from './signer';
import { StacksTransaction } from './transaction';
import { createLPList } from './types';
import { cvToHex, omit, parseReadOnlyResponse, validateTxId } from './utils';
export function getNonce(_x, _x2) {
  return _getNonce.apply(this, arguments);
}

function _getNonce() {
  _getNonce = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(address, network) {
    var derivedNetwork, url, response, msg, responseText, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : new StacksMainnet());
            url = derivedNetwork.getAccountApiUrl(address);
            _context.next = 4;
            return derivedNetwork.fetchFn(url);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 16;
              break;
            }

            msg = '';
            _context.prev = 7;
            _context.next = 10;
            return response.text();

          case 10:
            msg = _context.sent;
            _context.next = 15;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](7);

          case 15:
            throw new Error("Error fetching nonce. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 16:
            _context.next = 18;
            return response.text();

          case 18:
            responseText = _context.sent;
            result = JSON.parse(responseText);
            return _context.abrupt("return", BigInt(result.nonce));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 13]]);
  }));
  return _getNonce.apply(this, arguments);
}

export function estimateTransfer(_x3, _x4) {
  return _estimateTransfer.apply(this, arguments);
}

function _estimateTransfer() {
  _estimateTransfer = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(transaction, network) {
    var requestHeaders, fetchOptions, derivedNetwork, url, response, msg, feeRateResult, txBytes, feeRate;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(transaction.payload.payloadType !== PayloadType.TokenTransfer)) {
              _context2.next = 2;
              break;
            }

            throw new Error("Transaction fee estimation only possible with ".concat(PayloadType[PayloadType.TokenTransfer], " transactions. Invoked with: ").concat(PayloadType[transaction.payload.payloadType]));

          case 2:
            requestHeaders = {
              Accept: 'application/text'
            };
            fetchOptions = {
              method: 'GET',
              headers: requestHeaders
            };
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : deriveNetwork(transaction));
            url = derivedNetwork.getTransferFeeEstimateApiUrl();
            _context2.next = 8;
            return derivedNetwork.fetchFn(url, fetchOptions);

          case 8:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 20;
              break;
            }

            msg = '';
            _context2.prev = 11;
            _context2.next = 14;
            return response.text();

          case 14:
            msg = _context2.sent;
            _context2.next = 19;
            break;

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](11);

          case 19:
            throw new Error("Error estimating transaction fee. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 20:
            _context2.next = 22;
            return response.text();

          case 22:
            feeRateResult = _context2.sent;
            txBytes = BigInt(transaction.serialize().byteLength);
            feeRate = BigInt(feeRateResult);
            return _context2.abrupt("return", feeRate * txBytes);

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[11, 17]]);
  }));
  return _estimateTransfer.apply(this, arguments);
}

export function estimateTransaction(_x5, _x6, _x7) {
  return _estimateTransaction.apply(this, arguments);
}

function _estimateTransaction() {
  _estimateTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(transactionPayload, estimatedLen, network) {
    var options, derivedNetwork, url, response, msg, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(Object.assign({
                transaction_payload: bytesToHex(serializePayload(transactionPayload))
              }, estimatedLen ? {
                estimated_len: estimatedLen
              } : {}))
            };
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : new StacksMainnet());
            url = derivedNetwork.getTransactionFeeEstimateApiUrl();
            _context3.next = 5;
            return derivedNetwork.fetchFn(url, options);

          case 5:
            response = _context3.sent;

            if (response.ok) {
              _context3.next = 17;
              break;
            }

            msg = '';
            _context3.prev = 8;
            _context3.next = 11;
            return response.text();

          case 11:
            msg = _context3.sent;
            _context3.next = 16;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](8);

          case 16:
            throw new Error("Error estimating transaction fee. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 17:
            _context3.next = 19;
            return response.json();

          case 19:
            data = _context3.sent;
            return _context3.abrupt("return", data.estimations);

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[8, 14]]);
  }));
  return _estimateTransaction.apply(this, arguments);
}

export function broadcastTransaction(_x8, _x9, _x10) {
  return _broadcastTransaction.apply(this, arguments);
}

function _broadcastTransaction() {
  _broadcastTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(transaction, network, attachment) {
    var rawTx, derivedNetwork, url;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            rawTx = transaction.serialize();
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : deriveNetwork(transaction));
            url = derivedNetwork.getBroadcastApiUrl();
            return _context4.abrupt("return", broadcastRawTransaction(rawTx, url, attachment, derivedNetwork.fetchFn));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _broadcastTransaction.apply(this, arguments);
}

export function broadcastRawTransaction(_x11, _x12, _x13) {
  return _broadcastRawTransaction.apply(this, arguments);
}

function _broadcastRawTransaction() {
  _broadcastRawTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(rawTx, url, attachment) {
    var fetchFn,
        options,
        response,
        text,
        txid,
        isValidTxId,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            fetchFn = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : createFetchFn();
            options = {
              method: 'POST',
              headers: {
                'Content-Type': attachment ? 'application/json' : 'application/octet-stream'
              },
              body: attachment ? JSON.stringify({
                tx: bytesToHex(rawTx),
                attachment: bytesToHex(attachment)
              }) : rawTx
            };
            _context5.next = 4;
            return fetchFn(url, options);

          case 4:
            response = _context5.sent;

            if (response.ok) {
              _context5.next = 15;
              break;
            }

            _context5.prev = 6;
            _context5.next = 9;
            return response.json();

          case 9:
            return _context5.abrupt("return", _context5.sent);

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](6);
            throw Error("Failed to broadcast transaction: ".concat(_context5.t0.message));

          case 15:
            _context5.next = 17;
            return response.text();

          case 17:
            text = _context5.sent;
            txid = text.replace(/["]+/g, '');
            isValidTxId = validateTxId(txid);

            if (isValidTxId) {
              _context5.next = 22;
              break;
            }

            throw new Error(text);

          case 22:
            return _context5.abrupt("return", {
              txid: txid
            });

          case 23:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[6, 12]]);
  }));
  return _broadcastRawTransaction.apply(this, arguments);
}

export function getAbi(_x14, _x15, _x16) {
  return _getAbi.apply(this, arguments);
}

function _getAbi() {
  _getAbi = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(address, contractName, network) {
    var options, derivedNetwork, url, response, msg;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            options = {
              method: 'GET'
            };
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network);
            url = derivedNetwork.getAbiApiUrl(address, contractName);
            _context6.next = 5;
            return derivedNetwork.fetchFn(url, options);

          case 5:
            response = _context6.sent;

            if (response.ok) {
              _context6.next = 11;
              break;
            }

            _context6.next = 9;
            return response.text().catch(function () {
              return '';
            });

          case 9:
            msg = _context6.sent;
            throw new Error("Error fetching contract ABI for contract \"".concat(contractName, "\" at address ").concat(address, ". Response ").concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 11:
            _context6.t0 = JSON;
            _context6.next = 14;
            return response.text();

          case 14:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.parse.call(_context6.t0, _context6.t1));

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getAbi.apply(this, arguments);
}

function deriveNetwork(transaction) {
  switch (transaction.version) {
    case TransactionVersion.Mainnet:
      return new StacksMainnet();

    case TransactionVersion.Testnet:
      return new StacksTestnet();
  }
}

export function makeUnsignedSTXTokenTransfer(_x17) {
  return _makeUnsignedSTXTokenTransfer.apply(this, arguments);
}

function _makeUnsignedSTXTokenTransfer() {
  _makeUnsignedSTXTokenTransfer = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(txOptions) {
    var defaultOptions, options, payload, authorization, spendingCondition, network, postConditions, lpPostConditions, transaction, estimatedLen, txFee, addressVersion, senderAddress, txNonce;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            defaultOptions = {
              fee: BigInt(0),
              nonce: BigInt(0),
              network: new StacksMainnet(),
              postConditionMode: PostConditionMode.Deny,
              memo: '',
              sponsored: false
            };
            options = Object.assign(defaultOptions, txOptions);
            payload = createTokenTransferPayload(options.recipient, options.amount, options.memo);
            authorization = null;
            spendingCondition = null;

            if ('publicKey' in options) {
              spendingCondition = createSingleSigSpendingCondition(AddressHashMode.SerializeP2PKH, options.publicKey, options.nonce, options.fee);
            } else {
              spendingCondition = createMultiSigSpendingCondition(AddressHashMode.SerializeP2SH, options.numSignatures, options.publicKeys, options.nonce, options.fee);
            }

            if (options.sponsored) {
              authorization = createSponsoredAuth(spendingCondition);
            } else {
              authorization = createStandardAuth(spendingCondition);
            }

            network = StacksNetwork.fromNameOrNetwork(options.network);
            postConditions = [];

            if (options.postConditions && options.postConditions.length > 0) {
              options.postConditions.forEach(function (postCondition) {
                postConditions.push(postCondition);
              });
            }

            lpPostConditions = createLPList(postConditions);
            transaction = new StacksTransaction(network.version, authorization, payload, lpPostConditions, options.postConditionMode, options.anchorMode, network.chainId);

            if (!(txOptions.fee === undefined || txOptions.fee === null)) {
              _context7.next = 18;
              break;
            }

            estimatedLen = estimateTransactionByteLength(transaction);
            _context7.next = 16;
            return estimateTransaction(payload, estimatedLen, options.network);

          case 16:
            txFee = _context7.sent;
            transaction.setFee(txFee[1].fee);

          case 18:
            if (!(txOptions.nonce === undefined || txOptions.nonce === null)) {
              _context7.next = 25;
              break;
            }

            addressVersion = options.network.version === TransactionVersion.Mainnet ? AddressVersion.MainnetSingleSig : AddressVersion.TestnetSingleSig;
            senderAddress = c32address(addressVersion, transaction.auth.spendingCondition.signer);
            _context7.next = 23;
            return getNonce(senderAddress, options.network);

          case 23:
            txNonce = _context7.sent;
            transaction.setNonce(txNonce);

          case 25:
            return _context7.abrupt("return", transaction);

          case 26:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _makeUnsignedSTXTokenTransfer.apply(this, arguments);
}

export function makeSTXTokenTransfer(_x18) {
  return _makeSTXTokenTransfer.apply(this, arguments);
}

function _makeSTXTokenTransfer() {
  _makeSTXTokenTransfer = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(txOptions) {
    var publicKey, options, transaction, privKey, signer, _options, _transaction, _signer, pubKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!('senderKey' in txOptions)) {
              _context8.next = 12;
              break;
            }

            publicKey = publicKeyToString(getPublicKey(createStacksPrivateKey(txOptions.senderKey)));
            options = omit(txOptions, 'senderKey');
            _context8.next = 5;
            return makeUnsignedSTXTokenTransfer(Object.assign({
              publicKey: publicKey
            }, options));

          case 5:
            transaction = _context8.sent;
            privKey = createStacksPrivateKey(txOptions.senderKey);
            signer = new TransactionSigner(transaction);
            signer.signOrigin(privKey);
            return _context8.abrupt("return", transaction);

          case 12:
            _options = omit(txOptions, 'signerKeys');
            _context8.next = 15;
            return makeUnsignedSTXTokenTransfer(_options);

          case 15:
            _transaction = _context8.sent;
            _signer = new TransactionSigner(_transaction);
            pubKeys = txOptions.publicKeys;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context8.prev = 21;

            _loop = function _loop() {
              var key = _step.value;
              var pubKey = pubKeyfromPrivKey(key);
              pubKeys = pubKeys.filter(function (pk) {
                return pk !== bytesToHex(pubKey.data);
              });

              _signer.signOrigin(createStacksPrivateKey(key));
            };

            for (_iterator = txOptions.signerKeys[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              _loop();
            }

            _context8.next = 30;
            break;

          case 26:
            _context8.prev = 26;
            _context8.t0 = _context8["catch"](21);
            _didIteratorError = true;
            _iteratorError = _context8.t0;

          case 30:
            _context8.prev = 30;
            _context8.prev = 31;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 33:
            _context8.prev = 33;

            if (!_didIteratorError) {
              _context8.next = 36;
              break;
            }

            throw _iteratorError;

          case 36:
            return _context8.finish(33);

          case 37:
            return _context8.finish(30);

          case 38:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context8.prev = 41;

            for (_iterator2 = pubKeys[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              key = _step2.value;

              _signer.appendOrigin(publicKeyFromBytes(hexToBytes(key)));
            }

            _context8.next = 49;
            break;

          case 45:
            _context8.prev = 45;
            _context8.t1 = _context8["catch"](41);
            _didIteratorError2 = true;
            _iteratorError2 = _context8.t1;

          case 49:
            _context8.prev = 49;
            _context8.prev = 50;

            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }

          case 52:
            _context8.prev = 52;

            if (!_didIteratorError2) {
              _context8.next = 55;
              break;
            }

            throw _iteratorError2;

          case 55:
            return _context8.finish(52);

          case 56:
            return _context8.finish(49);

          case 57:
            return _context8.abrupt("return", _transaction);

          case 58:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[21, 26, 30, 38], [31,, 33, 37], [41, 45, 49, 57], [50,, 52, 56]]);
  }));
  return _makeSTXTokenTransfer.apply(this, arguments);
}

export function estimateContractDeploy(_x19, _x20) {
  return _estimateContractDeploy.apply(this, arguments);
}

function _estimateContractDeploy() {
  _estimateContractDeploy = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9(transaction, network) {
    var requestHeaders, fetchOptions, derivedNetwork, url, response, msg, feeRateResult, txBytes, feeRate;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(transaction.payload.payloadType !== PayloadType.SmartContract)) {
              _context9.next = 2;
              break;
            }

            throw new Error("Contract deploy fee estimation only possible with ".concat(PayloadType[PayloadType.SmartContract], " transactions. Invoked with: ").concat(PayloadType[transaction.payload.payloadType]));

          case 2:
            requestHeaders = {
              Accept: 'application/text'
            };
            fetchOptions = {
              method: 'GET',
              headers: requestHeaders
            };
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : deriveNetwork(transaction));
            url = derivedNetwork.getTransferFeeEstimateApiUrl();
            _context9.next = 8;
            return derivedNetwork.fetchFn(url, fetchOptions);

          case 8:
            response = _context9.sent;

            if (response.ok) {
              _context9.next = 14;
              break;
            }

            _context9.next = 12;
            return response.text().catch(function () {
              return '';
            });

          case 12:
            msg = _context9.sent;
            throw new Error("Error estimating contract deploy fee. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 14:
            _context9.next = 16;
            return response.text();

          case 16:
            feeRateResult = _context9.sent;
            txBytes = intToBigInt(transaction.serialize().byteLength, false);
            feeRate = intToBigInt(feeRateResult, false);
            return _context9.abrupt("return", feeRate * txBytes);

          case 20:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _estimateContractDeploy.apply(this, arguments);
}

export function makeContractDeploy(_x21) {
  return _makeContractDeploy.apply(this, arguments);
}

function _makeContractDeploy() {
  _makeContractDeploy = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee10(txOptions) {
    var privKey, stacksPublicKey, publicKey, unsignedTxOptions, transaction, signer;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            privKey = createStacksPrivateKey(txOptions.senderKey);
            stacksPublicKey = getPublicKey(privKey);
            publicKey = publicKeyToString(stacksPublicKey);
            unsignedTxOptions = Object.assign(Object.assign({}, txOptions), {
              publicKey: publicKey
            });
            _context10.next = 6;
            return makeUnsignedContractDeploy(unsignedTxOptions);

          case 6:
            transaction = _context10.sent;

            if (txOptions.senderKey) {
              signer = new TransactionSigner(transaction);
              signer.signOrigin(privKey);
            }

            return _context10.abrupt("return", transaction);

          case 9:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _makeContractDeploy.apply(this, arguments);
}

export function makeUnsignedContractDeploy(_x22) {
  return _makeUnsignedContractDeploy.apply(this, arguments);
}

function _makeUnsignedContractDeploy() {
  _makeUnsignedContractDeploy = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee11(txOptions) {
    var defaultOptions, options, payload, addressHashMode, pubKey, authorization, spendingCondition, network, postConditions, lpPostConditions, transaction, estimatedLen, txFee, addressVersion, senderAddress, txNonce;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            defaultOptions = {
              fee: BigInt(0),
              nonce: BigInt(0),
              network: new StacksMainnet(),
              postConditionMode: PostConditionMode.Deny,
              sponsored: false
            };
            options = Object.assign(defaultOptions, txOptions);
            payload = createSmartContractPayload(options.contractName, options.codeBody);
            addressHashMode = AddressHashMode.SerializeP2PKH;
            pubKey = createStacksPublicKey(options.publicKey);
            authorization = null;
            spendingCondition = createSingleSigSpendingCondition(addressHashMode, publicKeyToString(pubKey), options.nonce, options.fee);

            if (options.sponsored) {
              authorization = createSponsoredAuth(spendingCondition);
            } else {
              authorization = createStandardAuth(spendingCondition);
            }

            network = StacksNetwork.fromNameOrNetwork(options.network);
            postConditions = [];

            if (options.postConditions && options.postConditions.length > 0) {
              options.postConditions.forEach(function (postCondition) {
                postConditions.push(postCondition);
              });
            }

            lpPostConditions = createLPList(postConditions);
            transaction = new StacksTransaction(network.version, authorization, payload, lpPostConditions, options.postConditionMode, options.anchorMode, network.chainId);

            if (!(txOptions.fee === undefined || txOptions.fee === null)) {
              _context11.next = 19;
              break;
            }

            estimatedLen = estimateTransactionByteLength(transaction);
            _context11.next = 17;
            return estimateTransaction(payload, estimatedLen, options.network);

          case 17:
            txFee = _context11.sent;
            transaction.setFee(txFee[1].fee);

          case 19:
            if (!(txOptions.nonce === undefined || txOptions.nonce === null)) {
              _context11.next = 26;
              break;
            }

            addressVersion = options.network.version === TransactionVersion.Mainnet ? AddressVersion.MainnetSingleSig : AddressVersion.TestnetSingleSig;
            senderAddress = publicKeyToAddress(addressVersion, pubKey);
            _context11.next = 24;
            return getNonce(senderAddress, options.network);

          case 24:
            txNonce = _context11.sent;
            transaction.setNonce(txNonce);

          case 26:
            return _context11.abrupt("return", transaction);

          case 27:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _makeUnsignedContractDeploy.apply(this, arguments);
}

export function estimateContractFunctionCall(_x23, _x24) {
  return _estimateContractFunctionCall.apply(this, arguments);
}

function _estimateContractFunctionCall() {
  _estimateContractFunctionCall = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee12(transaction, network) {
    var requestHeaders, fetchOptions, derivedNetwork, url, response, msg, feeRateResult, txBytes, feeRate;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!(transaction.payload.payloadType !== PayloadType.ContractCall)) {
              _context12.next = 2;
              break;
            }

            throw new Error("Contract call fee estimation only possible with ".concat(PayloadType[PayloadType.ContractCall], " transactions. Invoked with: ").concat(PayloadType[transaction.payload.payloadType]));

          case 2:
            requestHeaders = {
              Accept: 'application/text'
            };
            fetchOptions = {
              method: 'GET',
              headers: requestHeaders
            };
            derivedNetwork = StacksNetwork.fromNameOrNetwork(network !== null && network !== void 0 ? network : deriveNetwork(transaction));
            url = derivedNetwork.getTransferFeeEstimateApiUrl();
            _context12.next = 8;
            return derivedNetwork.fetchFn(url, fetchOptions);

          case 8:
            response = _context12.sent;

            if (response.ok) {
              _context12.next = 14;
              break;
            }

            _context12.next = 12;
            return response.text().catch(function () {
              return '';
            });

          case 12:
            msg = _context12.sent;
            throw new Error("Error estimating contract call fee. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 14:
            _context12.next = 16;
            return response.text();

          case 16:
            feeRateResult = _context12.sent;
            txBytes = intToBigInt(transaction.serialize().byteLength, false);
            feeRate = intToBigInt(feeRateResult, false);
            return _context12.abrupt("return", feeRate * txBytes);

          case 20:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _estimateContractFunctionCall.apply(this, arguments);
}

export function makeUnsignedContractCall(_x25) {
  return _makeUnsignedContractCall.apply(this, arguments);
}

function _makeUnsignedContractCall() {
  _makeUnsignedContractCall = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13(txOptions) {
    var defaultOptions, options, payload, abi, spendingCondition, authorization, network, postConditions, lpPostConditions, transaction, estimatedLen, txFee, addressVersion, senderAddress, txNonce;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            defaultOptions = {
              fee: BigInt(0),
              nonce: BigInt(0),
              network: new StacksMainnet(),
              postConditionMode: PostConditionMode.Deny,
              sponsored: false
            };
            options = Object.assign(defaultOptions, txOptions);
            payload = createContractCallPayload(options.contractAddress, options.contractName, options.functionName, options.functionArgs);

            if (!(options === null || options === void 0 ? void 0 : options.validateWithAbi)) {
              _context13.next = 16;
              break;
            }

            if (!(typeof options.validateWithAbi === 'boolean')) {
              _context13.next = 14;
              break;
            }

            if (!(options === null || options === void 0 ? void 0 : options.network)) {
              _context13.next = 11;
              break;
            }

            _context13.next = 8;
            return getAbi(options.contractAddress, options.contractName, options.network);

          case 8:
            abi = _context13.sent;
            _context13.next = 12;
            break;

          case 11:
            throw new Error('Network option must be provided in order to validate with ABI');

          case 12:
            _context13.next = 15;
            break;

          case 14:
            abi = options.validateWithAbi;

          case 15:
            validateContractCall(payload, abi);

          case 16:
            spendingCondition = null;
            authorization = null;

            if ('publicKey' in options) {
              spendingCondition = createSingleSigSpendingCondition(AddressHashMode.SerializeP2PKH, options.publicKey, options.nonce, options.fee);
            } else {
              spendingCondition = createMultiSigSpendingCondition(AddressHashMode.SerializeP2SH, options.numSignatures, options.publicKeys, options.nonce, options.fee);
            }

            if (options.sponsored) {
              authorization = createSponsoredAuth(spendingCondition);
            } else {
              authorization = createStandardAuth(spendingCondition);
            }

            network = StacksNetwork.fromNameOrNetwork(options.network);
            postConditions = [];

            if (options.postConditions && options.postConditions.length > 0) {
              options.postConditions.forEach(function (postCondition) {
                postConditions.push(postCondition);
              });
            }

            lpPostConditions = createLPList(postConditions);
            transaction = new StacksTransaction(network.version, authorization, payload, lpPostConditions, options.postConditionMode, options.anchorMode, network.chainId);

            if (!(txOptions.fee === undefined || txOptions.fee === null)) {
              _context13.next = 31;
              break;
            }

            estimatedLen = estimateTransactionByteLength(transaction);
            _context13.next = 29;
            return estimateTransaction(payload, estimatedLen, network);

          case 29:
            txFee = _context13.sent;
            transaction.setFee(txFee[1].fee);

          case 31:
            if (!(txOptions.nonce === undefined || txOptions.nonce === null)) {
              _context13.next = 38;
              break;
            }

            addressVersion = network.version === TransactionVersion.Mainnet ? AddressVersion.MainnetSingleSig : AddressVersion.TestnetSingleSig;
            senderAddress = c32address(addressVersion, transaction.auth.spendingCondition.signer);
            _context13.next = 36;
            return getNonce(senderAddress, network);

          case 36:
            txNonce = _context13.sent;
            transaction.setNonce(txNonce);

          case 38:
            return _context13.abrupt("return", transaction);

          case 39:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _makeUnsignedContractCall.apply(this, arguments);
}

export function makeContractCall(_x26) {
  return _makeContractCall.apply(this, arguments);
}

function _makeContractCall() {
  _makeContractCall = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14(txOptions) {
    var publicKey, options, transaction, privKey, signer, _options2, _transaction2, _signer2, _pubKeys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop2, _iterator3, _step3, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, key;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!('senderKey' in txOptions)) {
              _context14.next = 12;
              break;
            }

            publicKey = publicKeyToString(getPublicKey(createStacksPrivateKey(txOptions.senderKey)));
            options = omit(txOptions, 'senderKey');
            _context14.next = 5;
            return makeUnsignedContractCall(Object.assign({
              publicKey: publicKey
            }, options));

          case 5:
            transaction = _context14.sent;
            privKey = createStacksPrivateKey(txOptions.senderKey);
            signer = new TransactionSigner(transaction);
            signer.signOrigin(privKey);
            return _context14.abrupt("return", transaction);

          case 12:
            _options2 = omit(txOptions, 'signerKeys');
            _context14.next = 15;
            return makeUnsignedContractCall(_options2);

          case 15:
            _transaction2 = _context14.sent;
            _signer2 = new TransactionSigner(_transaction2);
            _pubKeys = txOptions.publicKeys;
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context14.prev = 21;

            _loop2 = function _loop2() {
              var key = _step3.value;
              var pubKey = pubKeyfromPrivKey(key);
              _pubKeys = _pubKeys.filter(function (pk) {
                return pk !== bytesToHex(pubKey.data);
              });

              _signer2.signOrigin(createStacksPrivateKey(key));
            };

            for (_iterator3 = txOptions.signerKeys[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              _loop2();
            }

            _context14.next = 30;
            break;

          case 26:
            _context14.prev = 26;
            _context14.t0 = _context14["catch"](21);
            _didIteratorError3 = true;
            _iteratorError3 = _context14.t0;

          case 30:
            _context14.prev = 30;
            _context14.prev = 31;

            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }

          case 33:
            _context14.prev = 33;

            if (!_didIteratorError3) {
              _context14.next = 36;
              break;
            }

            throw _iteratorError3;

          case 36:
            return _context14.finish(33);

          case 37:
            return _context14.finish(30);

          case 38:
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context14.prev = 41;

            for (_iterator4 = _pubKeys[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              key = _step4.value;

              _signer2.appendOrigin(publicKeyFromBytes(hexToBytes(key)));
            }

            _context14.next = 49;
            break;

          case 45:
            _context14.prev = 45;
            _context14.t1 = _context14["catch"](41);
            _didIteratorError4 = true;
            _iteratorError4 = _context14.t1;

          case 49:
            _context14.prev = 49;
            _context14.prev = 50;

            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }

          case 52:
            _context14.prev = 52;

            if (!_didIteratorError4) {
              _context14.next = 55;
              break;
            }

            throw _iteratorError4;

          case 55:
            return _context14.finish(52);

          case 56:
            return _context14.finish(49);

          case 57:
            return _context14.abrupt("return", _transaction2);

          case 58:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[21, 26, 30, 38], [31,, 33, 37], [41, 45, 49, 57], [50,, 52, 56]]);
  }));
  return _makeContractCall.apply(this, arguments);
}

export function makeStandardSTXPostCondition(address, conditionCode, amount) {
  return createSTXPostCondition(createStandardPrincipal(address), conditionCode, amount);
}
export function makeContractSTXPostCondition(address, contractName, conditionCode, amount) {
  return createSTXPostCondition(createContractPrincipal(address, contractName), conditionCode, amount);
}
export function makeStandardFungiblePostCondition(address, conditionCode, amount, assetInfo) {
  return createFungiblePostCondition(createStandardPrincipal(address), conditionCode, amount, assetInfo);
}
export function makeContractFungiblePostCondition(address, contractName, conditionCode, amount, assetInfo) {
  return createFungiblePostCondition(createContractPrincipal(address, contractName), conditionCode, amount, assetInfo);
}
export function makeStandardNonFungiblePostCondition(address, conditionCode, assetInfo, assetName) {
  return createNonFungiblePostCondition(createStandardPrincipal(address), conditionCode, assetInfo, assetName);
}
export function makeContractNonFungiblePostCondition(address, contractName, conditionCode, assetInfo, assetName) {
  return createNonFungiblePostCondition(createContractPrincipal(address, contractName), conditionCode, assetInfo, assetName);
}
export function callReadOnlyFunction(_x27) {
  return _callReadOnlyFunction.apply(this, arguments);
}

function _callReadOnlyFunction() {
  _callReadOnlyFunction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee15(readOnlyFunctionOptions) {
    var defaultOptions, options, contractName, contractAddress, functionName, functionArgs, senderAddress, network, url, args, body, response, msg;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            defaultOptions = {
              network: new StacksMainnet()
            };
            options = Object.assign(defaultOptions, readOnlyFunctionOptions);
            contractName = options.contractName, contractAddress = options.contractAddress, functionName = options.functionName, functionArgs = options.functionArgs, senderAddress = options.senderAddress;
            network = StacksNetwork.fromNameOrNetwork(options.network);
            url = network.getReadOnlyFunctionCallApiUrl(contractAddress, contractName, functionName);
            args = functionArgs.map(function (arg) {
              return cvToHex(arg);
            });
            body = JSON.stringify({
              sender: senderAddress,
              arguments: args
            });
            _context15.next = 9;
            return network.fetchFn(url, {
              method: 'POST',
              body: body,
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 9:
            response = _context15.sent;

            if (response.ok) {
              _context15.next = 15;
              break;
            }

            _context15.next = 13;
            return response.text().catch(function () {
              return '';
            });

          case 13:
            msg = _context15.sent;
            throw new Error("Error calling read-only function. Response ".concat(response.status, ": ").concat(response.statusText, ". Attempted to fetch ").concat(url, " and failed with the message: \"").concat(msg, "\""));

          case 15:
            return _context15.abrupt("return", response.json().then(function (responseJson) {
              return parseReadOnlyResponse(responseJson);
            }));

          case 16:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _callReadOnlyFunction.apply(this, arguments);
}

export function sponsorTransaction(_x28) {
  return _sponsorTransaction.apply(this, arguments);
}

function _sponsorTransaction() {
  _sponsorTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee16(sponsorOptions) {
    var defaultOptions, options, network, sponsorPubKey, txFee, estimatedLen, addressVersion, senderAddress, sponsorNonce, sponsorSpendingCondition, privKey, signer;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            defaultOptions = {
              fee: 0,
              sponsorNonce: 0,
              sponsorAddressHashmode: AddressHashMode.SerializeP2PKH,
              network: sponsorOptions.transaction.version === TransactionVersion.Mainnet ? new StacksMainnet() : new StacksTestnet()
            };
            options = Object.assign(defaultOptions, sponsorOptions);
            network = StacksNetwork.fromNameOrNetwork(options.network);
            sponsorPubKey = pubKeyfromPrivKey(options.sponsorPrivateKey);

            if (!(sponsorOptions.fee === undefined || sponsorOptions.fee === null)) {
              _context16.next = 23;
              break;
            }

            txFee = 0;
            _context16.t0 = options.transaction.payload.payloadType;
            _context16.next = _context16.t0 === PayloadType.TokenTransfer ? 9 : _context16.t0 === PayloadType.SmartContract ? 9 : _context16.t0 === PayloadType.ContractCall ? 9 : 20;
            break;

          case 9:
            estimatedLen = estimateTransactionByteLength(options.transaction);
            _context16.prev = 10;
            _context16.next = 13;
            return estimateTransaction(options.transaction.payload, estimatedLen, network);

          case 13:
            txFee = _context16.sent[1].fee;
            _context16.next = 19;
            break;

          case 16:
            _context16.prev = 16;
            _context16.t1 = _context16["catch"](10);
            throw _context16.t1;

          case 19:
            return _context16.abrupt("break", 21);

          case 20:
            throw new Error("Sponsored transactions not supported for transaction type ".concat(PayloadType[options.transaction.payload.payloadType]));

          case 21:
            options.transaction.setFee(txFee);
            options.fee = txFee;

          case 23:
            if (!(sponsorOptions.sponsorNonce === undefined || sponsorOptions.sponsorNonce === null)) {
              _context16.next = 30;
              break;
            }

            addressVersion = network.version === TransactionVersion.Mainnet ? AddressVersion.MainnetSingleSig : AddressVersion.TestnetSingleSig;
            senderAddress = publicKeyToAddress(addressVersion, sponsorPubKey);
            _context16.next = 28;
            return getNonce(senderAddress, network);

          case 28:
            sponsorNonce = _context16.sent;
            options.sponsorNonce = sponsorNonce;

          case 30:
            sponsorSpendingCondition = createSingleSigSpendingCondition(options.sponsorAddressHashmode, publicKeyToString(sponsorPubKey), options.sponsorNonce, options.fee);
            options.transaction.setSponsor(sponsorSpendingCondition);
            privKey = createStacksPrivateKey(options.sponsorPrivateKey);
            signer = TransactionSigner.createSponsorSigner(options.transaction, sponsorSpendingCondition);
            signer.signSponsor(privKey);
            return _context16.abrupt("return", signer.transaction);

          case 36:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[10, 16]]);
  }));
  return _sponsorTransaction.apply(this, arguments);
}

export function estimateTransactionByteLength(transaction) {
  var hashMode = transaction.auth.spendingCondition.hashMode;
  var multiSigHashModes = [AddressHashMode.SerializeP2SH, AddressHashMode.SerializeP2WSH];

  if (multiSigHashModes.includes(hashMode)) {
    var multiSigSpendingCondition = transaction.auth.spendingCondition;
    var existingSignatures = multiSigSpendingCondition.fields.filter(function (field) {
      return field.contents.type === StacksMessageType.MessageSignature;
    }).length;
    var totalSignatureLength = (multiSigSpendingCondition.signaturesRequired - existingSignatures) * (RECOVERABLE_ECDSA_SIG_LENGTH_BYTES + 1);
    return transaction.serialize().byteLength + totalSignatureLength;
  } else {
    return transaction.serialize().byteLength;
  }
}